import $ from 'jquery';

$.fn.Tooltip = function() {
  var tooltip = $('.TooltipBody');
  tooltip.css({
    'z-index': 100,
  });
  tooltip.find('.TooltipLabel').css({ 'white-space': 'nowrap' });
  var method = {
    //イベント
    addEvent(_this) {
      var label = $(_this).attr('data-label');
      // ツールチップ表示
      _this.hover(
        function() {
          //Use tooltip for toolbar's object edit tabs when it's disabled
          if (_this.hasClass('Tooltip')) {
            tooltip.find('.TooltipLabel').text(label);
            let header =
              $('.global-header').is(':visible') &&
              $('.global-header').height() != undefined
                ? $('.global-header').height()
                : 0;
            let _top = _this.offset().top + 40 - header;
            let _left = 0;
            _left =
              _this.position().left + _this.width() / 2 - tooltip.width() / 2;
            tooltip.css({
              top: `${_top + tooltip.closest('.rail__main').scrollTop() + 5}px`,
              left: `${_left + tooltip.closest('.rail__main').scrollLeft()}px`,
            });
            tooltip.addClass('show');
          }
        },
        function() {
          tooltip.removeClass('show');
        }
      );
    },
  };

  return this.each(function() {
    var _this = $(this);

    method.addEvent(_this);
  });
};



// WEBPACK FOOTER //
// ./src/canvas/common/tooltip.js